import React, { useEffect, useState } from 'react';
import '../Styles/Gallery.css';
import GalleryImg from '../Assets/BackgroundImg3.png';
import Footer from './Footer';
import social1 from '../Assets/defaults/social1.jpg'
import social2 from '../Assets/defaults/social2.jpg';
import social3 from '../Assets/defaults/social3.jpg'; 
import social4 from '../Assets/defaults/social4.jpg';
import social5 from '../Assets/defaults/social5.jpg';
import social6 from '../Assets/defaults/social6.jpg'; 
import social7 from '../Assets/defaults/social7.jpg'; 
import social8 from '../Assets/defaults/social8.jpg'; 
import Institution1 from '../Assets/defaults/Institution1.jpg'; 
import Institution2 from '../Assets/defaults/Institution2.jpg';
import Institution3 from '../Assets/defaults/Institution3.jpg';
import Institution4 from '../Assets/defaults/Institution4.jpg';
import Institution5 from '../Assets/defaults/Institution5.jpg';
import Institution6 from '../Assets/defaults/Institution6.jpg';
import Institution7 from '../Assets/defaults/Institution7.jpg';
import Institution8 from '../Assets/defaults/Institution8.jpg';

const API_BASE = 'https://gainwissdom.onrender.com';

// ✅ Move defaults OUTSIDE the component (fixes parsing & warnings)
const defaultSocialImages = [
  social1,
  social2,
  social3,  
  social4,
  social5,
  social6,
  social7,
  social8,
];

const defaultInstitutionImages = [
  Institution1,
  Institution2,
  Institution3,
  Institution4,
  Institution5,
  Institution6,
  Institution7,
  Institution8,
];

const defaultVideoLinks = [
  {
    link: 'https://www.youtube.com/embed/gZ_tzNldYPA',
    description: 'Rubicon Hindusthan',
  },
  {
    link: 'https://www.youtube.com/embed/vnUGnYgoguA',
    description: 'Rathinam Faculty Training',
  },
  {
    link: 'https://www.youtube.com/embed/O4s-5rN_FVg',
    description: 'Developing Hints',
  },
  {
    link: 'https://www.youtube.com/embed/hphTScANSgM',
    description: 'College Training',
  },
];

const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentSet, setCurrentSet] = useState([]);
  const [socialImages, setSocialImages] = useState([]);
  const [institutionImages, setInstitutionImages] = useState([]);
  const [videoLinks, setVideoLinks] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/api/upload/list`)
      .then((res) => res.json())
      .then((data) => {
        const fetchedSocial = data.social.map((file) => file.url);
        const fetchedInstitution = data.institution.map((file) => file.url);
        setSocialImages([...defaultSocialImages, ...fetchedSocial]);
        setInstitutionImages([...defaultInstitutionImages, ...fetchedInstitution]);
      })
      .catch((err) => {
        console.error('Failed to load images', err);
        setSocialImages(defaultSocialImages);
        setInstitutionImages(defaultInstitutionImages);
      });

    fetch(`${API_BASE}/api/videos`)
      .then((res) => res.json())
      .then((data) => {
        setVideoLinks([...defaultVideoLinks, ...data]);
      })
      .catch((err) => {
        console.error('Failed to load videos', err);
        setVideoLinks(defaultVideoLinks);
      });
  }, []); // ✅ No more ESLint dependency warning

  const openModal = (images, index) => {
    setCurrentSet(images);
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? currentSet.length - 1 : prev - 1));
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev === currentSet.length - 1 ? 0 : prev + 1));
  };

  return (
    <div>
      {/* Banner Section */}
      <div className="home-banner">
        <img src={GalleryImg} alt="Home Banner" className="home-img" />
        <button
          className="home-btn"
          onClick={() => window.open('https://gainwisdom.in/', '_blank')}
        >
          Start Learning
        </button>
      </div>

      <div className="gallery-container">
        <h2 className="gallery-title">Gallery</h2>

        {/* Social Media Highlights */}
        <section className="gallery-section">
          <h3>Social Media Highlights</h3>
          <div className="image-grid">
            {socialImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Social ${index + 1}`}
                onClick={() => openModal(socialImages, index)}
              />
            ))}
          </div>
        </section>

        {/* YouTube Videos */}
        <section className="gallery-section">
          <h3>YouTube Videos</h3>
          <div className="video-grid">
            {videoLinks.map((video, index) => (
              <div className="video-item" key={index}>
                <iframe
                  src={video.link}
                  title={`video-${index}`}
                  allowFullScreen
                ></iframe>
                <p className="video-caption">{video.description}</p>
              </div>
            ))}
          </div>
          <div className="video-text">
            <p>
              <a
                href="https://www.youtube.com/@jeseefrancis7779"
                target="_blank"
                rel="noopener noreferrer"
              >
                Follow for more videos -&gt;
              </a>
            </p>
          </div>
        </section>

        {/* Institution Program Images */}
        <section className="gallery-section">
          <h3>Institution Program</h3>
          <div className="image-grid">
            {institutionImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Institution ${index + 1}`}
                onClick={() => openModal(institutionImages, index)}
              />
            ))}
          </div>
        </section>

        {/* Modal Viewer */}
        {isOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <span className="close-btn" onClick={closeModal}>
              ×
            </span>
            <span
              className="nav-btn left"
              onClick={(e) => {
                e.stopPropagation();
                prevImage();
              }}
            >
              &lt;
            </span>
            <img
              src={currentSet[currentIndex]}
              alt="Full View"
              className="modal-image"
            />
            <span
              className="nav-btn right"
              onClick={(e) => {
                e.stopPropagation();
                nextImage();
              }}
            >
              &gt;
            </span>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Gallery;
